import React, { Fragment, useState } from "react";
import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { store } from "../store";
import { store as globalStore } from "@components/VerticalLayout/store";

import { CustomIcons } from "./CustomIcons";
import SaleForm from "./SaleForm";
import { useAuthHeader } from "../../../../../api/headersKeycloak";
import {
    useSyncDefaultSettingSaleSupport,
    useInitSaleSupportUrl,
} from "./hooks";

export function SaleSupport() {
    const { t } = useTranslation();
    const { franchiseID } = useSnapshot(globalStore);
    const getAuthHeader = useAuthHeader();

    const [filterActive, setLocalFilterActive] = useState<boolean>(false);
    const [isAddSaleClicked, setIsAddSaleClicked] = useState<boolean>(false);
    const [dataIsUpdated, setDataIsUpdated] = useState<boolean | number>(false);
    const [data, setData] = useState<any>({});
    const [rowData, setRowData] = useState<any>({});
    const { defaultSetting } = useSnapshot(store);
    const [url, setUrl] = useState<any>("/DefaultSetting/saleSupport.json");

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 1,
            columnName: t("Display name"),

            customJsx: (e: any) => (
                <Fragment>{t(e.selectedRow["Nom d'affichage"])}</Fragment>
            ),
        },
        {
            indexOFColumn: 2,
            columnName: t("Sales support"),
            customJsx: (e: any) => (
                <Fragment>{t(e.selectedRow.support_de_vente)}</Fragment>
            ),
            filterName: "display_name",
            canFilter: true,
        },
        {
            indexOFColumn: 3,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setRowData={setRowData}
                    setIsAddSaleClicked={setIsAddSaleClicked}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    setIsAddSaleSupportClicked={setIsAddSaleClicked}
                />
            ),
            disableFilter: false,
        },
    ];

    useSyncDefaultSettingSaleSupport(data, defaultSetting);
    useInitSaleSupportUrl(franchiseID, setUrl);
    return (
        <div>
            <h2 className="mt-3 ml-3">{t("Sales support")}</h2>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: isAddSaleClicked ? "2fr 1fr " : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    requestHeader={{
                        ...getAuthHeader,
                    }}
                    canMovedCheckboxLeftOnExpand
                    url={url}
                    setData={setData}
                    canSelect
                    customSelect
                    canResize
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight={"450px"}
                    maxHeight={"450px"}
                    name="tva"
                />
                {isAddSaleClicked ? (
                    <SaleForm
                        setIsAddSaleSupportClicked={setIsAddSaleClicked}
                        saleSupport={rowData}
                        data={data.data}
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        isAddSaleSupportClicked={isAddSaleClicked}
                        setRowData={setRowData}
                    />
                ) : null}
            </div>
        </div>
    );
}
